<template>
    <div class="row d-none d-xl-flex">
        <div class="col-xl-4">
            <div class="note">{{$t('components.BasketPackHeader.name')}}</div>
        </div>
        <div class="col-xl-8 col-xxl-8">
            <div class="orderRow">
                <div class="orderRow__item orderRow__item--md">
                    <div class="note">{{$t('components.BasketPackHeader.quantity')}}</div>
                </div>
                <div class="orderRow__item orderRow__item--title">
                    <div class="note">{{$t('components.BasketPackHeader.description')}}</div>
                </div>
                <div class="orderRow__item orderRow__item--sm text-right">
                    <div class="note">{{$t('components.BasketPackHeader.price')}}</div>
                </div>
                <div class="orderRow__item orderRow__item--remove"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BasketPackHeader"
    }
</script>

<style scoped>

</style>
